import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';

import useRecommendationsContext from './RecommendationsContext';

const Container = styled.div`
  display: flex;
  gap: 5px;
`;

const ResetContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: 10px;
  padding: 0px 10px;
  margin: 10px 5px;
  border-left: 1px solid var(--line-gray);
`;

const Link = styled.span`
  color: var(--text-secondary);
  font-size: 10px;
  cursor: pointer;
`;

interface RecommendationFiltersProps {
  hideCommunitiesFilter?: boolean;
}

const RecommendationFilters = ({ hideCommunitiesFilter }: RecommendationFiltersProps) => {
  const { filters, categoryOptions, communityOptions, careTypeOptions, updateFilters, resetFilters } =
    useRecommendationsContext();

  const handleSelection = (filedName: string) => (selection: any) => {
    updateFilters({ ...filters, [filedName]: selection.map((c: any) => c.value) });
  };

  return (
    <Container>
      {!hideCommunitiesFilter && (
        <SelectAdvancedFilter
          placeholder="Community"
          options={communityOptions}
          defaultValue={filters.communities}
          onSelect={handleSelection('communities')}
          className={classNames({ active: filters.communities.length > 0 })}
        />
      )}
      <SelectAdvancedFilter
        placeholder="Care Type"
        options={careTypeOptions}
        defaultValue={filters.careTypes}
        onSelect={handleSelection('careTypes')}
        className={classNames({ active: filters.careTypes.length > 0 })}
      />
      <SelectAdvancedFilter
        placeholder="Category"
        options={categoryOptions}
        defaultValue={filters.categories}
        onSelect={handleSelection('categories')}
        className={classNames({ active: filters.categories.length > 0 })}
      />
      <ResetContainer>
        <Link onClick={resetFilters}>Reset</Link>
      </ResetContainer>
    </Container>
  );
};

export default RecommendationFilters;
